module.exports = require("live/components/ui/form/color-picker");